import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import Modal from 'react-modal';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import Navbar from './components/Navbar';
import Hero from './components/homepage/Hero';
import HeroAboutUs from './components/aboutUs/HeroAboutUs';
import HeroContactUs from './components/contactUs/HeroContactUs';
import HeroTransport from './components/transport/HeroTransport';
import HeroForwarding from './components/forwarding/HeroForwarding';
import HeroTrack from './components/track/HeroTrack';
import HeroBrokerage from './components/brokerage/HeroBrokerage';
import HeroProject from './components/project/HeroProject';
import HeroSeaLand from './components/sealand/HeroSeaLand';
import AboutUs from './components/aboutUs/HeroAboutUs';
import HeroGallery from './components/gallery/HeroGallery';
import HeroTeam from './components/team/HeroTeam';
import HeroPrivacy from './components/privacy/HeroPrivacy';
import Footer from './components/Footer';
import './App.css';

const GOOGLE_TAG_ID = 'G-92ZE6BS0LE';

// Component to handle automatic scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Jump instantly to top without smooth animation
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // 'auto' also works for instant jump
    });
  }, [pathname]);

  return null;
}

const loadGoogleAnalytics = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    gtag('js', new Date());
    gtag('config', GOOGLE_TAG_ID);
};

// const trackButtonClick = (buttonName) => {
//     if (window.dataLayer) {
//         window.dataLayer.push({
//             event: 'button_click',
//             button_name: buttonName
//         });
//     }
// };

function App() {
    Modal.setAppElement('#root');

    const [isCookieModalOpen, setIsCookieModalOpen] = useState(() => {
        const consent = localStorage.getItem('cookieConsent') !== 'true';
        return consent;
    });

    useEffect(() => {
        if (localStorage.getItem('cookieConsent') === 'true') {
            const script = document.createElement('script');
            script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_TAG_ID}`;
            script.async = true;
            document.head.appendChild(script);
            loadGoogleAnalytics();
        }
    }, []);

    const handleAcceptCookies = () => {
        localStorage.setItem('cookieConsent', 'true');
        setIsCookieModalOpen(false);
        const script = document.createElement('script');
        script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_TAG_ID}`;
        script.async = true;
        document.head.appendChild(script);
        loadGoogleAnalytics();
    };

    const handleDeclineCookies = () => {
        localStorage.setItem('cookieConsent', 'false');
        setIsCookieModalOpen(false);
    };

    return (
        <Router>
            <div className="App">
                <Helmet>
                    <title>RCS Logistics Philippines - Moving You Forward</title>
                    <meta name="description" content="Partner with RCS Logistics Philippines to ensure your transportation is in expert hands, guaranteeing smooth deliveries and exceptional service." />
                    <script async src={`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_TAG_ID}`}></script>
                    <script>{`
                        window.dataLayer = window.dataLayer || [];
                        function gtag(){dataLayer.push(arguments);}
                        gtag('js', new Date());
                        gtag('config', '${GOOGLE_TAG_ID}');
                    `}</script>
                </Helmet>

                <ScrollToTop />
                <Navbar />
                <Routes>
                    <Route path="/" element={<Hero />} />
                    <Route path="/aboutUs" element={<AboutUs />} />
                    <Route path="/transport" element={<HeroTransport />} />
                    <Route path="/forwarding" element={<HeroForwarding />} />
                    <Route path="/track" element={<HeroTrack />} />
                    <Route path="/brokerage" element={<HeroBrokerage />} />
                    <Route path="/project" element={<HeroProject />} />
                    <Route path="/sealand" element={<HeroSeaLand />} />
                    <Route path="/aboutUs" element={<HeroAboutUs />} />
                    <Route path="/contactUs" element={<HeroContactUs />} />
                    <Route path="/gallery" element={<HeroGallery />} />
                    <Route path="/team" element={<HeroTeam />} />
                    <Route path="/privacy" element={<HeroPrivacy />} />
                </Routes>
                
                <Footer />

                {isCookieModalOpen && (
                    <Modal
                        isOpen={isCookieModalOpen}
                        onRequestClose={handleDeclineCookies}
                        contentLabel="Cookie Consent Banner"
                        className="cookie-banner"
                        overlayClassName="cookie-banner-overlay"
                    >
                        <div className="cookie-banner-content">
                            <div className="cookie-text">
                                <i className="fas fa-cookie-bite cookie-icon-small"></i>
                                <span className="cookie-message">
                                    This website uses cookies to enhance your browsing experience and analyze site traffic. 
                                    <a href="/privacy" className="cookie-privacy-link">Learn more</a>
                                </span>
                            </div>
                            <div className="cookie-banner-actions">
                                <button onClick={handleDeclineCookies} className="cookie-banner-btn decline">
                                    Decline
                                </button>
                                <button onClick={handleAcceptCookies} className="cookie-banner-btn accept">
                                    Accept
                                </button>
                            </div>
                        </div>
                    </Modal>
                )}
            </div>
        </Router>
    );
}

export default App;
